import { render, staticRenderFns } from "./StockImages.vue?vue&type=template&id=8b51dc1e"
import script from "./StockImages.vue?vue&type=script&lang=js"
export * from "./StockImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports